var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C4.41015 2 1.5 4.91015 1.5 8.5C1.5 12.0899 4.41015 15 8 15C11.5899 15 14.5 12.0899 14.5 8.5C14.5 4.91015 11.5899 2 8 2ZM0.5 8.5C0.5 4.35786 3.85786 1 8 1C12.1421 1 15.5 4.35786 15.5 8.5C15.5 12.6421 12.1421 16 8 16C3.85786 16 0.5 12.6421 0.5 8.5Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25977 4.23438C7.25977 4.03125 7.32812 3.86133 7.46484 3.72461C7.60547 3.58398 7.77734 3.51367 7.98047 3.51367C8.1875 3.51367 8.36133 3.58203 8.50195 3.71875C8.64648 3.85547 8.71875 4.02734 8.71875 4.23438C8.71875 4.4375 8.64648 4.60742 8.50195 4.74414C8.36133 4.87695 8.1875 4.94336 7.98047 4.94336C7.77344 4.94336 7.60156 4.87695 7.46484 4.74414C7.32812 4.60742 7.25977 4.4375 7.25977 4.23438ZM7.39453 13V6.51953H8.54297V13H7.39453Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9dd6da6eee359178c47c9f0bb228ebd5.svg";
export { ForwardRef as ReactComponent };